import { useEffect } from "react"
import { useBlocker } from "react-router-dom"
import { useBeforeUnload } from "react-use"

export function usePrompt(message: string, when = true) {
	const blocker = useBlocker(when)

	useBeforeUnload(when, message)

	useEffect(() => {
		if (blocker.state === "blocked") {
			if (window.confirm(message)) blocker.proceed()
			else blocker.reset()
		}
	}, [blocker, message])
}
